import { useCallback, useMemo } from 'react';

import { useRouter, useRouterActions } from 'react-resource-router';

import { RepositoryQuery } from 'src/sections/profile/types';
import { stringify } from 'src/urls/utils';

import { parseQuery, toQueryParams } from '../workspace-repositories-resource';

type UseWorkspaceRepositoriesQuery = {
  setQuery: (query: RepositoryQuery) => void;
  query: RepositoryQuery;
};

export const useWorkspaceRepositoriesQuery =
  (): UseWorkspaceRepositoriesQuery => {
    const [{ query, location }] = useRouter();
    const { pathname } = location;
    const { push } = useRouterActions();
    const parsedQuery = useMemo(() => parseQuery(query), [query]);

    const setQuery = useCallback(
      (repositoryQuery: RepositoryQuery) => {
        push(
          `${pathname}${stringify({
            ...query,
            ...toQueryParams(repositoryQuery),
          })}`
        );
      },
      [pathname, push, query]
    );

    return { setQuery, query: parsedQuery };
  };
